import React, { useMemo } from 'react';
import SegmentedPolylineOverlay from './SegmentedPolylineOverlay';

const rsrpColors = [
  '#9c27b0', // purple - unknown
  '#d32f2f', // red - very poor
  '#f57c00', // orange - poor
  '#fbc02d', // yellow - fair
  '#1976d2', // blue - good
  '#388e3c', // green - excellent
];

const ranges = [
  { min: -80, max: 0, color: rsrpColors[5], description: 'Excellent' },
  { min: -90, max: -80, color: rsrpColors[4], description: 'Good' },
  { min: -100, max: -90, color: rsrpColors[3], description: 'Fair' },
  { min: -110, max: -100, color: rsrpColors[2], description: 'Poor' },
  { min: -140, max: -110, color: rsrpColors[1], description: 'Very Poor' },
  { min: -Infinity, max: -140, color: rsrpColors[0], description: 'Unknown' },
];

const legendFormatter = r =>
  r.min === -Infinity
    ? `Unknown`
    : r.max === 0
    ? `${r.min}+ dBm (${r.description})`
    : `${r.min} to ${r.max} dBm (${r.description})`;

export default function LteRSRPOverlay({ routes }) {
  // routes: array of segments (arrays of points)
  const allPoints = useMemo(() => routes.flat(), [routes]);

  // Only render overlay if there are points
  if (!allPoints.length) return null;

  return (
    <SegmentedPolylineOverlay
      segments={routes}
      valueSelector={pt => pt.lteRSRP ?? -Infinity}
      ranges={ranges}
      legendTitle="LTE Strength"
      legendFormatter={legendFormatter}
      units="dBm"
      discrete={false}
    />
  );
}